module.exports = __webpack_public_path__ + "media/images/icons/twotone/funnel-plot-35ee0da8f2f0a55050b5189a264b5f83.svg";